import { IDEAL_MINIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID, MAXIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID } from 'mapping/constants';
import { IMappableSetting } from 'types/map';

export default function getMapZoomLimitsForSetting({ mapRootArea: { areaKey } }: Pick<IMappableSetting, 'mapRootArea'>) {
  return {
    min: IDEAL_MINIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID[areaKey],
    max: MAXIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID[areaKey],
  };
}